module.exports = __webpack_public_path__ + "assets/img/sznyyq.9dd83d6b.png";